import "./_style.scss";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkTable from "../../components/atoms/TkTable";
import { httpIAPI_CON018 } from "./api/request";
import { headList, monthMapping } from "./parts";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkTitle from "../../components/atoms/TkTitle";
import { UnrecognizedMonthList } from "../../type/apiType/IAPI_CON018";
import { TkGetCode } from "../../utils/TkGetCode";
import {
  FacilityKind,
  HalfYearExtensionReason,
  YesOrNoFlug,
} from "../../assets/data/Constants";

/**
 * SCRC050111 従業状況確認
 * @return SCRC050111 従業状況確認
 */
const SCRC050111 = () => {
  const navigate = useNavigate();

  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);

  const [bodyList, setBodyList] = useState<any>([]);

  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;

  const location = useLocation();
  const facilityNo =
    businessState.job_16?.facilityNo || location?.state?.facilityNo || "";
  const facilityKindName =
    FacilityKind[location?.state?.kindCd as keyof typeof FacilityKind];

  const { facilityName = "" } = location?.state || {};

  useEffect(() => {
    callApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const callApi = async () => {
    try {
      // 従業状況一覧参照API実行
      const res = await httpIAPI_CON018({
        contractorNo: isKiko
          ? businessState.common?.contractorNo
          : state.authInfo?.contractorNo,
        facilityNo,
        cancelDate: location.state?.cancelDate,
        cancelTarget: location.state?.cancelTarget,
        applyId: location.state?.applyId,
      });

      if (res.resultCd === "I0000") {
        const statusReferBodyList = funBodyList(res);
        setBodyList(statusReferBodyList);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch {
      navigate("/error");
    }
  };

  // ならない月リストの変換処理
  const renderMonth = (unrecognizedMonthList: UnrecognizedMonthList[]) => {
    let newList: string[] = [];
    unrecognizedMonthList?.forEach?.((item) => {
      for (const [key, value] of Object.entries(item)) {
        if (value === "1") {
          const str = monthMapping[key] + "月";
          newList.push(str);
        }
      }
    });
    return newList?.join?.("、");
  };

  function funBodyList(res: any): any[] {
    const bodyList = res.staffList?.map((item: any) => {
      return [
        {
          children: `${item.staffNo}:${item.staffNameKanji}`,
        },
        {
          children: item.joinDate,
          align: "center",
        },
        {
          children: item.retireDate,
          align: "center",
        },
        {
          children: renderMonth(item.unrecognizedMonthList || []),
        },
        {
          children: item.childcareList && (
            <>
              <Box className="SCRC050111br">
                出生日：{item.childcareList[0]?.birthday}
              </Box>
              <Box className="SCRC050111br">
                期間：{item.childcareList[0]?.startDate}-
                {item.childcareList[0]?.endDate}
              </Box>
              <Box className="SCRC050111br">
                パパママ育休プラス：
                {TkGetCode(YesOrNoFlug, item.childcareList[0]?.papaMamaPlus)}
              </Box>
              <Box className="SCRC050111br">
                半年延長の理由：
                {TkGetCode(
                  HalfYearExtensionReason,
                  item.childcareList[0]?.halfyearExtendReason
                )}
              </Box>
            </>
          ),
        },
      ];
    });
    return bodyList;
  }

  return (
    <Box data-testid="SCRC050111PageForTest" className="SCRC050111">
      {isKiko && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={`${businessState.common?.contractorNo ?? ""}:${
            businessState.common?.contractorName ?? ""
          }`}
        />
      )}
      <TkTitle>
        {facilityNo}:{facilityName}&nbsp;施設種類&nbsp;{facilityKindName}
      </TkTitle>
      <TkTable
        headList={headList}
        bodyList={bodyList}
        defaultRowsPerPage={10}
        pagin={true}
      />
      <Box className="butt">
        <TkBackButton
          useBackParam
          navigateParam={{
            facilityNo: facilityNo,
          }}
        />
      </Box>
    </Box>
  );
};

export default SCRC050111;
